import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import {
  itemPriceManagementBrowseAccessControl,
  itemPriceManagementModifyAccessControl,
  itemPriceManagementReviewRouteAccessControl,
} from '../access-control/itemPriceManagementAccess.configuration'

const ItemPriceManagementTabbedPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementTabbedPage" */
      '../pages/ItemPriceManagementTabbedPage'
    )
)
const ItemPriceManagementChangeRequestPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementChangeRequestPage" */
      '../pages/change-request/ItemPriceManagementChangeRequestPage'
    )
)
const ItemPriceManagementChangeRequestReviewRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementChangeRequestReviewRoute" */
      '../pages/change-request-review/ItemPriceManagementChangeRequestReviewRoute'
    )
)
// @hygen:inject page-import

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestCreatePage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="create" />
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestViewPage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="view" />
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestEditPage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="edit" />
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
// This exact route must be registered before itemPriceManagementRouter: the ordinary parent
// also prefix-matches the review URL, but Partner Approvers intentionally lack its browse gate.
export const itemPriceManagementReviewRouter = (
  <DomainRoute
    exact
    route="item-price-management-change-request-review"
    accessControl={itemPriceManagementReviewRouteAccessControl}
    component={ItemPriceManagementChangeRequestReviewRoute as any}
  />
)

export const itemPriceManagementRouter = (
  <DomainRoute route="item-price-management" accessControl={itemPriceManagementBrowseAccessControl}>
    <DashSwitch>
      {/* Detail routes (more specific paths first) */}
      <DomainRoute
        exact
        route="item-price-management-active-rules"
        component={ItemPriceManagementTabbedPage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-create"
        accessControl={itemPriceManagementModifyAccessControl}
        component={ChangeRequestCreatePage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-edit"
        accessControl={itemPriceManagementModifyAccessControl}
        component={ChangeRequestEditPage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-detail"
        component={ChangeRequestViewPage}
      />
      {/* Tabbed page routes */}
      <DomainRoute
        exact
        route="item-price-management-change-requests"
        component={ItemPriceManagementTabbedPage}
      />
      {/* Default redirect for base path */}
      <DomainRedirect
        fromRoute="item-price-management"
        toRoute="item-price-management-change-requests"
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
